import { useEffect, useState } from 'react';
import api from '../services/api';

export function useResourceCategories() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get('resources/categories');

        const { resourceCategories, numResources } = response.data;

        const merged = resourceCategories.map((category) => {
          const match = numResources.find((r) => r.categoryId === category.id);
          return {
            ...category,
            amountResources: match ? match.amountResources : 0,
          };
        });

        setData(merged);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { data, loading, error };
}
